import { render, staticRenderFns } from "./subtask-details.vue?vue&type=template&id=63687c9c&scoped=true&"
import script from "./subtask-details.vue?vue&type=script&lang=js&"
export * from "./subtask-details.vue?vue&type=script&lang=js&"
import style0 from "./subtask-details.vue?vue&type=style&index=0&id=63687c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63687c9c",
  null
  
)

export default component.exports